<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter" :onClose="onClose">
    <div v-if="content === 'content1'">
      <label class="generalLabel" v-if="modalSelected == 'RecibirDispositivo'">Se va a aceptar la recepción del dispositivo,
        pulse "Confirmar" para continuar.</label>
      <label class="generalLabel" v-if="modalSelected == 'Cancelar'">Se va a cancelar la cancelación, pulse "Confirmar" para
        continuar.</label>
      <label class="generalLabel" v-if="modalSelected == 'RevisadoConDefectos'">Se va a aceptar la cancelación con
        defectos, pulse "Confirmar" para continuar.</label>
      <label class="generalLabel" v-if="modalSelected == 'RevisadoSinDefectos'">Se va a aceptar la cancelación sin
        defectos, pulse "Confirmar" para continuar.</label>
      <label class="generalLabel" v-if="modalSelected == 'StartProcess'">Se va a aceptar el inicio del proceso, pulse "Confirmar" para continuar.</label>
      <div class="float-right">
        <img v-if="loading" src="../../../../assets/loaderPrimary.svg" height="50" alt="">
        <button class="btn btn-primary generalPrimaryButton" aria-label="Close"
          @click="cancellation()"
          v-if="!loading"
          >Confirmar</button>
      </div>

    </div>
    <div v-if="content === 'content2'">
      <label class="generalLabel">Se ha realizado la operación correctamente.</label>
    </div>
    <div v-if="content === 'content3'">
      <label class="generalLabel">Ha ocurrido un error al realizar la operación.</label>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../Widgets/Shared/Modal.vue';
import axios from 'axios';

export default {
  name: 'ConfirmCancellation',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'numContract',
    'requestCancellationId',
    'statusSelected',
    'modalSelected',
  ],
  components: {
    Modal
  },
  data() {
    return {
      classes: this.class,
      content: 'content1',
      loading: false,
    }
  },
  methods: {
    cancellation() {
      // let bodyToSend = {
      //   status: this.statusSelected.toUpperCase()
      // }
      this.loading = true
      let url = '';
      switch (this.modalSelected) {
        case "RecibirDispositivo":
        url = `/contract/request/cancellation/${this.requestCancellationId}/receive-device-callback`;
          break;
        case "Cancelar":
          url = `/contract/request/cancellation/${this.requestCancellationId}/cancel-callback`;
          break;
        case "RevisadoConDefectos":
        case "RevisadoSinDefectos":
          url = `/contract/request/cancellation/${this.requestCancellationId}/device-status-callback/${this.statusSelected.toLowerCase()}`;
          break;
        case "StartProcess":
          url = `/contract/request/cancellation/${this.requestCancellationId}/init-process-callback`;
          break;
        default:
          break;
      }
      if (url !== '') {
        axios.post(url)
        .then(() => {
          this.loading = false;
          this.selectTab('content2');
          this.$emit("refreshCancellationList", this.statusSelected);
        })
        .catch(() => {
          this.loading = false;
          this.selectTab('content3');
        });
      } else {
        this.loading = false;
        this.selectTab('content3')
      }
    },
    selectTab(id) {
      this.content = id;
    },
    onClose() {
      this.content = 'content1';
      this.loading = false;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
